import { X } from "lucide-react";
import type { ReminderRule } from "@/features/business/types/businessTypes";
import { Button } from "@/shared/components/shadcn/Button";
import { InfoRow } from "@/shared/components/ui/InfoRow";

interface ReminderScheduleRowProps {
  rule: ReminderRule;
  disabled: boolean;
  onRemove: () => void;
}

export function ReminderScheduleRow({ rule, disabled, onRemove }: ReminderScheduleRowProps) {
  const minutes = rule.minutes_before;
  const unit = minutes % 1440 === 0 ? "day" : minutes % 60 === 0 ? "hour" : "minute";
  const amount = minutes / (unit === "day" ? 1440 : unit === "hour" ? 60 : 1);
  const label = `${amount} ${unit}${amount === 1 ? "" : "s"} before the appointment`;

  return (
    <InfoRow
      title={label}
      subtitle="Email reminder"
      density="compact"
      actions={
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={`Remove reminder ${label}`}
          disabled={disabled}
          onClick={onRemove}
        >
          <X aria-hidden="true" />
        </Button>
      }
    />
  );
}
